import Component from 'component';
import imagesLoaded from 'imagesloaded';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
import { BREAKPOINT } from '../constants/index';
import { jumpToTarget } from '../helpers/jumpToTarget';

class ProductsGallery extends Component {
  constructor(el) {
    super(el);
    this.initMainSlick();
    this.checkHash();
  }

  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.js-prod-gallery'),
      $sliderContainer: this.$el.find('.prod-gallery__inner')
    };
  }

  addListeners() {
    this.dom.$slider.on(
      'init reinit breakpoint afterChange',
      ::this.onAlignElements
    );
    $(window).on('resize', _debounce(::this.onAlignElements, 250));
    $(window).on('resize', ::this.onResize);
  }

  onAlignElements(event, $slick) {
    let $prodSlider;

    if (typeof $slick === 'undefined') {
      $prodSlider = this.dom.$slider;
      $slick = $prodSlider.slick('getSlick');
    } else {
      $prodSlider = $slick.$slider;
    }

    this.mediaAdjustments($prodSlider);
  }

  onResize() {
    this.dom.$slider.slick('setPosition');
  }
  initMainSlick() {
    const _that = this;
    //Main Carousel
    this.dom.$slider.slick({
      infinite: true,
      accessibility: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      waitForAnimate: false,
      prevArrow:
        '<img class="slick-prev slick-arrow" src="/dist/sites/bb/images/contentManaged/icons/icon-arrow-left-shadow.svg" alt="prev slide">',
      nextArrow:
        '<img class="slick-next slick-arrow" src="/dist/sites/bb/images/contentManaged/icons/icon-arrow-right-shadow.svg" alt="next slide">'
    });
    // Because Safari does not work reliably with the slick LazyLoaded event, we are using afterChange.
    // But, afterChange does not fire until a slide changes causing the first slide arrows and social icons to be misaligned.
    // The below code will quickly change to the next slide and then back to the first on page load.
    // This should be unnoticable to the user.
    const firstImg = $(this.dom.$slider).find(
      '.prod-gallery__slide-img-wrapper'
    )[1];
    const imgLoad = imagesLoaded(firstImg, () => {
      this.mediaAdjustments(this.dom.$slider);
      this.dom.$slider.slick('slickNext').slick('slickPrev');
      this.mediaAdjustments(this.dom.$slider);
    });
  }
  mediaAdjustments($prodSlider) {
    const $dots = $prodSlider.find('.slick-dots');
    if (
      !window.matchMedia(`screen and (min-width: ${BREAKPOINT.tablet}px)`)
        .matches
    ) {
      $dots.hide();
    } else {
      $dots.show();
    }
  }
  checkHash() {
    if (window.location.hash) {
      const slideId = window.location.hash.substr(1);
      const $selectedSlide = this.$el.find(`[data-guid="${slideId}"]`).first();
      const slideIndex = $selectedSlide.data('slick-index');

      if ($selectedSlide.length > 0) {
        const $parentSlider = $selectedSlide.closest('.slick-slider');
        $parentSlider.slick('slickGoTo', parseInt(slideIndex), true);
        jumpToTarget(this.dom.$slider);
      }
    }
  }
}

export default ProductsGallery;



// WEBPACK FOOTER //
// ./src/bb/js/components/ProductsGallery.js